jq223(document).ready(function ($) {
  var collectionFilter = {
    init: function (t) {
      collectionFilter.config = {
        collectionUrl: $('.js-collection-sidebar').data('collection-url'),
        filterItemClass: '.js-collection-sidebar__filter-item',
        productsContainer: $('.js-collection-grid__products'),
        productCount: $('.js-product-grid__count'),
        layout: $('.js-collection-layout'),
        sortInput: $('.js-collection-sort__input'),
        filterBtn: $('.js-collection-filter'),
        removeBtn: $('.js-collection-filter__remove-active-button'),
        url: window.location.origin + window.location.pathname
      },
        $.extend(collectionFilter.config, t),
        collectionFilter.loadActiveTags(),
        collectionFilter.setTagFilter();
      collectionFilter.removeTagFilter();
    },
    loadActiveTags: function () {
      $(collectionFilter.config.filterItemClass).each((function () {
        var t = $(this).data('tag');
        collectionFilter.config.url.indexOf(t) > -1 && $(this).attr('checked', 'checked');
        collectionFilter.config.filterBtn.attr('href', window.location.href);
      }));
    },
    setTagFilter: function () {
      $(document).on('change', collectionFilter.config.filterItemClass, (function () {

        var t = window.location.search;
        if (-1 !== t.indexOf('page')) {
          var o = t.split('&')[0];
          t = t.replace(o, '').replace('&', '?')
        }
        var e = $(this).closest('.collection-filter__inner').find(collectionFilter.config.filterItemClass + ':checked')
          , n = [];
        e.each((function (t, o) {
          var e = $(o).attr('data-tag');
          e && n.push(e);
        }
        ));
        var i = n.join('+');
        var l = collectionFilter.config.collectionUrl;
        i && (l += '/' + i),
          l += t,
          collectionFilter.config.filterBtn.attr('href', l);

        $('input[name="' + this.name + '"]').not(this).attr('checked', false);
      }));
    },
    removeTagFilter: function () {
      $(collectionFilter.config.removeBtn).on('click', (function () {
        var _this = $(this),
          tag = _this.attr('data-tag');

        $(collectionFilter.config.filterItemClass + ':checked').each(function () {
          if ($(this).attr('data-tag') === tag) {
            $(this).trigger('click');

            var clearType = $(this).closest('form').find('.js-clear-radio');

            if(clearType.length){
              clearType.trigger('click');
            }
          }         
        });

        _this.closest('li').hide();

        collectionFilter.config.filterBtn[0].click();
      }));
    }
  };

  $(document).ready(collectionFilter.init);
});